import { computed } from 'vue';
import { get } from 'lodash';

import useYardTaskEvent from './useYardTaskEvent';

import type { YardTaskTimelineEvent } from './types';
import type { UseYardTaskEventOptions } from './useYardTaskEvent';

/**
 * Composable for assigned event that extends base event composable
 * @param {YardTaskTimelineEvent} event
 * @param {UseYardTaskEventOptions} options
 * @returns {Object} Base event data plus assigned-specific data
 */
export default function useYardTaskAssignedEvent(
  event: YardTaskTimelineEvent,
  options: UseYardTaskEventOptions
) {
  const baseEventData = useYardTaskEvent(event, options);

  const newAssigneeId = computed(() => {
    return get(event, 'data.data.newAssignee') || null;
  });

  const previousAssigneeId = computed(() => {
    return get(event, 'data.data.previousAssignee') || null;
  });

  return {
    ...baseEventData,
    newAssigneeId,
    previousAssigneeId
  };
}
